import { render } from "./ProductSaleListPage.vue?vue&type=template&id=2e217a63&scoped=true"
import script from "./ProductSaleListPage.vue?vue&type=script&lang=js"
export * from "./ProductSaleListPage.vue?vue&type=script&lang=js"

import "./ProductSaleListPage.vue?vue&type=style&index=0&id=2e217a63&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2e217a63"

export default script